<template>
  <section style="padding-top: 0px; padding-bottom: 0px;">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div id="player"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ['lang'],
  name: "Player",
  data() {
    return {
      video: ''
    };
  },
  mounted() {
    if(this.lang == 'es'){
      this.video = 'https://live1.xegmenta.com/vods3/_definst_/smil:amazons3/xegmentavod/sura/2019/incoterms/es/videoe.smil/playlist.m3u8';
    }else if(this.lang == 'pt'){
      this.video = 'https://live1.xegmenta.com/vods3/_definst_/smil:amazons3/xegmentavod/sura/2019/incoterms/por/videoe.smil/playlist.m3u8';
    }
    console.log(this.video);
    window.jwplayer.key = "XKEzXKrNzEbdXMNJhH9GPlnJFZElaIME8FH5xozaTVc=";
    var jwconf = {
      playlist: [
        {
          image: "",
          sources: [
            {
              file: this.video
            }
          ]
        }
      ],
      skin: "seven",
      title: "Incoterms",
      width: "100%",
      height: "auto",
      aspectratio: "21:9",
      autostart: false,
      stretching: "fill",
      androidhls: true,
      hlshtml: true,
      analytics: {
        enabled: false,
        cookies: false
      },
      abouttext: "XEGMENTA HD STREAMING",
      aboutlink: "https://www.xegmenta.com"
    };
    window.jwplayer("player").setup(jwconf);
  }
};
</script>